export default class Listener<Type=any> {

    private events: {
        [key: string]: ((value: Type) => void)[]
    } = {};

    on(id: string, callback: (value: Type) => void) {

        if (this.events[id] == undefined) this.events[id] = [];

        this.events[id].push(callback);

    }

    off(id: string, callback: (value: Type) => void) {
        if (!this.events[id]) return;

        const i = this.events[id].indexOf(callback);

        if (i > -1) this.events[id].splice(i, 1);
    }

    clear(id: string) {
        delete this.events[id];
    }

    send(id: string, value: Type) {
        if (this.events[id] == undefined) return;

        for (let i = 0; i < this.events[id].length; i++) {
            const callback = this.events[id][i];
            callback(value);
        }
    }

}